import { LANGUAGE_NAMES, LOGIN_MODES } from '@/constants';
import mixinQuery from './query';

export default {
    mixins: [mixinQuery],
    methods: {
        addEvent(data, options = {}) {
            const lang = options.lang || this.$store.state.language || 'zh-CN';
            const mode = options.mode || this.query.mode || 1;

            this.$Countly.q.push([
                'add_event',
                {
                    ...data,
                    segmentation: {
                        ...data.segmentation,
                        语言: LANGUAGE_NAMES[lang],
                        登录方式: LOGIN_MODES[mode]
                    }
                }
            ]);
        },

        userDetails(data, options = {}) {
            const lang = options.lang || this.$store.state.language || 'zh-CN';
            const mode = options.mode || this.query.mode || 1;

            this.$Countly.q.push([
                'user_details',
                {
                    ...data,
                    custom: {
                        ...data.custom,
                        语言: LANGUAGE_NAMES[lang],
                        登录方式: LOGIN_MODES[mode]
                    }
                }
            ]);
        }
    }
};
